<template>
	<div class="footer">
		<div class="footer-b">
			<div class="footer-l">
				<div class="footer-l-item">
					<div class="footer-l-item-h" @click="tapNav('/', 0)">
						首页
					</div>
					<div class="footer-l-item-s">
						
					</div>
				</div>
				<div class="footer-l-item">
					<div class="footer-l-item-h" @click="tapNav('/about', 0)">
						关于我们
					</div>
					<div class="footer-l-item-s" @click="tapNav('/about', 0)">
						企业介绍
					</div>
					<div class="footer-l-item-s" @click="tapNav('/about', 1)">
						组织架构
					</div>
					<div class="footer-l-item-s" @click="tapNav('/about', 2)">
						资质荣誉
					</div>
					<div class="footer-l-item-s" @click="tapNav('/about', 3)">
						企业文化
					</div>
				</div>
				<div class="footer-l-item">
					<div class="footer-l-item-h" @click="tapNav('/service', 0)">
						业务与服务
					</div>
					<div class="footer-l-item-s" @click="tapNav('/service', 0)">
						开发与投资
					</div>
					<div class="footer-l-item-s" @click="tapNav('/service', 1)">
						工程总结
					</div>
					<div class="footer-l-item-s" @click="tapNav('/service', 2)">
						运维服务
					</div>
				</div>
				<div class="footer-l-item">
					<div class="footer-l-item-h" @click="tapNav('/product', 0)">
						应用场景
					</div>
					<!-- <div class="footer-l-item-s" @click="tapNav('/product', 0)">
						智能产品
					</div>
					<div class="footer-l-item-s" @click="tapNav('/product', 1)">
						智能制作
					</div> -->
				</div>
				<div class="footer-l-item">
					<div class="footer-l-item-h" @click="tapNav('/case', 0)">
						项目案例
					</div>
					<div class="footer-l-item-s" @click="tapNav('/case', 0)">
						合作伙伴
					</div>
					<div class="footer-l-item-s" @click="tapNav('/case', 1)">
						合作案例
					</div>
				</div>
				<div class="footer-l-item">
					<div class="footer-l-item-h" @click="tapNav('/medium', 0)">
						新闻媒体
					</div>
					<div class="footer-l-item-s" @click="tapNav('/medium', 0)">
						企业大事记
					</div>
					<div class="footer-l-item-s" @click="tapNav('/medium', 1)">
						业界新闻
					</div>
				</div>
				<div class="footer-l-item">
					<div class="footer-l-item-h" @click="tapNav('/download', 0)">
						下载中心
					</div>
				</div>
				<div class="footer-l-item">
					<div class="footer-l-item-h" @click="tapNav('/contactus', 0)">
						联系我们
					</div>
				</div>
				<div class="footer-l-item">
					<div class="footer-l-item-h">
						招贤纳士
					</div>
				</div>
			</div>
			<div class="footer-r">
				<div class="footer-r-h">
					<!-- <img class="img"/>
					<div>
						中概电力
					</div> -->
					<img src="../assets/logof.png" alt="">
				</div>
				<div class="footer-r-m">
					<div class="h">
						<div class="h-t">
							服务/招商
						</div>
						<div class="h-s">0571-86392006</div>
					</div>
					<div class="h">
						<div class="h-t">邮箱</div>
						<div class="h-s">zg@zgeec.com</div>
					</div>
				</div>
				<!-- <div class="footer-r-f">
					<div class="item">
						<div class="img"></div>
						<div class="title">公众号</div>
					</div>
					<div class="item">
						<div class="img"></div>
						<div class="title">抖音号</div>
					</div>
					<div class="item">
						<div class="img"></div>
						<div class="title">视频号</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="footer-f">
			Copyright © 2017-2025 浙江中概电力科技有限公司
			<div @click="tapUrl" style="cursor: pointer;"> 浙ICP备2024142688号-1 </div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'footer',
	  data() {
	    return {
	      list:[
			   "首页",
			   "关于我们",
			   "业务与服务",
			   "产品中心",
			   "项目案例",
			   "新闻媒体",
			   "下载中心",
			   "联系我们",
			   "招贤纳士",
		  ],
		  selectIndex:0
	    }
	  },
	  created() {
	  	
	  },
	  methods:{
		  taplist(index) {
			  this.selectIndex = index
		  },
		  tapNav(path, index) {
			this.$router.push({path, query:{index:index}})  
		  },
		  tapUrl(){
			  window.open("https://beian.miit.gov.cn/#/Integrated/index")
		  }
	  }
	}
</script>

<style lang="scss">
	.footer {
		width: 100%;
		background-color: #22A3D3;
		color:  white;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;  
		.footer-b {
			
			align-items: center;
			
			.footer-l {
				height: 100%;
				display: flex;
				justify-content: flex-start;
				box-sizing: border-box;
				.footer-l-item {
					flex: 1;
					height: 100%;
					.footer-l-item-h {
						color: #fff;
					}
					.footer-l-item-s {
						// opacity: 0.35;
						font-family: AlibabaPuHuiTi-Regular;
						font-weight: 400;
						color: #FFFFFF;
					}
				}
			}
			.footer-r {
				height: 100%;
				
				// opacity: 0.4;
				box-sizing: border-box;
				.footer-r-h {   
					display: flex;
					justify-content: flex-start;
					align-items: center;
					img {
						
					}
					
				}
				.footer-r-m {
					
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.h {
						.h-t {
							// opacity: 0.35;
							font-family: AlibabaPuHuiTi-Regular;
							font-weight: 400;
							color: #FFFFFF;
						}
						.h-s {
							font-family: AlibabaPuHuiTi-Regular;
							font-weight: 400;
							color: #FFFFFF;
						}
					}
				}
				.footer-r-f {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.item {
						display: flex;
						flex-direction: column;
						justify-content: flex-start;
						align-items: center;
						img {
							
						}
						.img {
							background-color: #D8D8D8;
						}
						.title {
							color: #FFFFFF;
							text-align: center;
						}
					}
				}
			}
		}
	    .footer-f {
			// opacity: 0.4;
			font-family: AlibabaPuHuiTi-Regular;
			font-weight: 400;
			color: #FFFFFF;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			border-top: 1px solid #aaa;
			.img {
				
			}
		}
	}
	.footer-l-item-s {
		cursor: pointer;
	}
	
	
	@media screen and (min-width: 1200px) {
		.footer {
			height: 450px;
			font-size: 16px;
			.footer-b {
				width: 1200px;
				height: 375px;
				display: flex;
				justify-content: space-between;
				
				.footer-l {
					width: calc(100% - 400px);
					height: 100%;
					padding: 40px 0;
					.footer-l-item {
						flex: 1;
						.footer-l-item-h {
							font-size: 15px;
							margin-bottom: 24px;
						}
						.footer-l-item-s {
							font-size: 15px;
							margin-bottom: 16px;
						}
					}
				}
				.footer-r {
					width: 400px;
					padding: 40px;
					border-left: 1px solid rgba(255, 255, 255, 0.3);
					.footer-r-h {
						width: 190px;
						height: 53px;
						img {
							width: 190px;
							height: 50px;
						}
						
					}
					.footer-r-m {
						margin-top: 39px;
						.h {
							width: 150px;
							.h-t {
								font-size: 16px;
							}
							.h-s {
								margin-top: 8px;
								font-size: 16px;
							}
						}
					}
					.footer-r-f {
						margin-top: 25px;
						.item {
							width: 72px;
							margin-right: 20px;
							img, .img {
								width: 72px;
								height: 72px;
							}
							.title {
								margin-top: 10px;
								font-size: 16px;
							}
						}
					}
				}
			}
		    .footer-f {
				width: 1200px;
				height: 75px;
				font-size: 14px;
				border-top: 1px solid #aaa;
				.img {
					width: 20px;
					height: 20px;
					margin-left: 5px;
					margin-right: 5px;
				}
				div {
					margin-left: 10px;
				}
			}
		}
		
	
	}
	@media screen and (max-width: 1200px) {
		.footer {
			// height: pa;
            padding: 0 30px;
			box-sizing: border-box;
			font-size: 15px;
			.footer-b {
				width: 100%;
				// height: 375px;
				display: flex;
				justify-content: space-between;
				
				.footer-l {  
					width: calc(100% - 230px);
					height: 100%;
					padding: 40px 0;
					.footer-l-item {
						flex: 1;
						.footer-l-item-h {
							font-size: 14px;
							margin-bottom: 18px;
						}
						.footer-l-item-s {
							font-size: 14px;
							margin-bottom: 12px;
						}
					}
				}
				.footer-r {
					width: 190px;
					padding: 20px;
					border-left: 1px solid rgba(255, 255, 255, 0.3);
					.footer-r-h {
						width: 150px;
						height: 30px;
						img {
							width: 150px;
							height: 36px;
						}
						
					}
					.footer-r-m {
						margin-top: 20px;
						.h {
							width: 120px;
							.h-t {
								font-size: 13px;
							}
							.h-s {
								margin-top: 5px;
								font-size: 13px;
							}
						}
					}
					.footer-r-f {
						margin-top: 18px;
						.item {
							width: 50px;
							margin-right: 20px;
							img, .img {
								width: 40px;
								height: 40px;
							}
							.title {
								margin-top: 6px;
								font-size: 13px;
							}
						}
					}
				}
			}
		    .footer-f {
				width: 100%;
				height: 40px;
				font-size: 13px;
				border-top: 1px solid #aaa;
				.img {
					width: 10px;
					height: 10px;
					margin-left: 3px;
					margin-right: 3px;
				}
				div {
					margin-left: 10px;
				}
			}
		}  
	}
	@media screen and (max-width: 880px) {
		.footer {
		    padding: 0 15px;
			box-sizing: border-box;
			font-size: 15px;
			.footer-b {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				
				.footer-l {  
					display: none;
				}
				.footer-r {
					width: 100%; 
					border-left: 0;
					.footer-r-h {
						width: 100%;
						height: 30px;
						img {
							width: 110px;
							height: 30px;
						}
						
					}
					.footer-r-m {
						margin-top: 10px;
						.h {
							width: 100%;
							.h-t {
								font-size: 13px;
							}
							.h-s {
								margin-top: 5px;
								font-size: 13px;
							}
						}
					}
					.footer-r-f {
						margin-top: 12px;
						.item {
							width: 50px;
							margin-right: 12px;
							img, .img {
								width: 40px;
								height: 40px;
							}
							.title {
								margin-top: 6px;
								font-size: 13px;
							}
						}
					}
				}
			}
		    .footer-f {
				width: 100%;
				height: 70px;
				font-size: 12px;
				border-top: 1px solid #aaa;
				flex-direction: column;
				align-items: center;
				.img {
					width: 10px;
					height: 10px;
					margin-left: 0px;
					margin-right: 0px;
				}
				div {
					margin-top: 3px;
				}
			}
		}  
	
	}
</style>